// Simple test for speech rate service functionality
import { speechRateService } from './speechRateService';
import { TranscriptEntry } from '../store/conversationSlice';

// Mock transcripts for testing
const createMockTranscript = (text: string, speaker: 'salesperson' | 'customer', minutesAgo: number): TranscriptEntry => ({
  id: `test_${Date.now()}`,
  text,
  speaker,
  timestamp: new Date(Date.now() - (minutesAgo * 60 * 1000)).toISOString(),
});

// Test function
export const testSpeechRateService = () => {
  console.log('🧪 Testing Speech Rate Service...');

  // Create test transcripts
  const testTranscripts: TranscriptEntry[] = [
    createMockTranscript('Hello how are you today?', 'salesperson', 0.5), // 5 words, 30 seconds ago
    createMockTranscript('I would like to discuss our new product offering', 'salesperson', 0.3), // 8 words, 18 seconds ago
    createMockTranscript('It has many great features', 'salesperson', 0.1), // 5 words, 6 seconds ago
    createMockTranscript('What do you think about that?', 'customer', 0.2), // 6 words, 12 seconds ago (customer)
  ];

  // Test analysis with 10-second window, max 15 words
  const analysis = speechRateService.analyzeSpeechRate(testTranscripts, 10, 15);
  
  console.log('📊 Speech Rate Analysis Result:', {
    totalWords: analysis.total_words,
    wordsPerMinute: analysis.words_per_minute,
    isTooFast: analysis.is_too_fast,
    timeWindow: analysis.time_window,
    maxWords: analysis.max_words,
    recentTranscripts: analysis.recent_transcripts.length,
  });

  // Test summary
  const summary = speechRateService.getSpeechRateSummary(analysis);

  // Test color
  const color = speechRateService.getSpeechRateColor(analysis);

  return analysis;
};

// Export for use in browser console
(window as any).testSpeechRateService = testSpeechRateService; 